module.exports = __webpack_public_path__ + "img/logo@2x.257975fe.png";